import { useMutation, useQueryClient } from "@tanstack/react-query";
import { http } from "../../utils/httpCommon";
import { useApiUrls } from "../useApiUrl";
import { useIsFeatureFlagEnabled } from "../../featureFlags/useIsFeatureFlagEnabled";
import { apiUrls } from "../../utils/apiUrls";

const SUMMARY_SHIPMENTS_DETAILS_QUERY_KEY = ["summary", "shipments", "details"];

export const useAutoSequenceRoutes = () => {
  const client = useQueryClient();
  const hookUrls = useApiUrls();
  const isEndpointHookEnabled = useIsFeatureFlagEnabled(
    "inbound-3763-endpoint-hook-client"
  );
  const { autoSequenceRoutes } = isEndpointHookEnabled ? hookUrls : apiUrls;
  return useMutation({
    mutationFn: async (routeIds: number[]) => {
      await http.post(autoSequenceRoutes(routeIds));
      return routeIds;
    },
    onMutate: () => {
      client.cancelQueries({
        queryKey: SUMMARY_SHIPMENTS_DETAILS_QUERY_KEY,
      });
    },
    onError: () => {
      client.invalidateQueries({
        queryKey: SUMMARY_SHIPMENTS_DETAILS_QUERY_KEY,
      });
    },
    onSettled: () => {
      client.invalidateQueries({
        queryKey: SUMMARY_SHIPMENTS_DETAILS_QUERY_KEY,
      });
    },
  });
};
